<h3 class="flex flex-wrap items-center" style="gap: 8px">
  @if (isPublished) {
    <span>🎉 Your site is live and available at:</span>
  } @else {
    <span>This site is currently draft. Once published it will be available at:</span>
  }

  <span class="flex items-center" style="gap: 8px">
    <a [href]="'https://' + url" class="raspberry-darker strong clickable" target="_blank">
      {{ url }}
    </a>

    <img
      class="clickable"
      [matTooltip]="'Copy site link'"
      src="/assets/iconography/copy.svg"
      alt="Copy"
      ngxClipboard
      [cbContent]="'https://' + url"
      (click)="copiedToClipboard()" />
  </span>
</h3>
